<section class="feature" [id]="feature.id">

  <div class="container">

    <div class="section-header">

      <span class="subtitle">
        {{ feature.subtitle }}
      </span>

      <h2>
        {{ feature.title }}
      </h2>

      <p>
        {{ feature.description }}
      </p>

    </div>


    <div class="feature-grid">

      @for (card of feature.cards; track card.id) {
      <div class="card">

        <img
          [src]="card.imgUrl"
          [alt]="card.title"
        >

        <div class="card-content">

          <h3>
            {{ card.title }}
          </h3>

          <p>
            {{ card.description }}
          </p>

           <a [routerLink]="['/' + environment.FeatureConfig.id, card.id]" class="primary-btn">
                {{ feature.featureButton }}
            </a>

        </div>

      </div>
      }

    </div>

  </div>

</section>
